import { render, staticRenderFns } from "./DialogChoosePositionSign.vue?vue&type=template&id=d6feb0bc&scoped=true"
import script from "./DialogChoosePositionSign.vue?vue&type=script&lang=js"
export * from "./DialogChoosePositionSign.vue?vue&type=script&lang=js"
import style0 from "./DialogChoosePositionSign.vue?vue&type=style&index=0&id=d6feb0bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6feb0bc",
  null
  
)

export default component.exports